import request from '@/utils/request';

const baseURL = process.env.VUE_APP_SORTING;

/**
 * 新增设备
 * @param {Object} data - 设备信息
 * @param {string} data.machineName - 设备名称
 * @param {string} data.machineCode - 设备编码
 * @param {number} data.chuteCount - 格口数量
 * @returns {Promise}
 */
export function addMachine(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/add',
    method: 'post',
    data
  });
}

/**
 * 修改设备
 * @param {Object} data - 设备信息
 * @param {number} data.id - 设备ID
 * @returns {Promise}
 */
export function updateMachine(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/update',
    method: 'post',
    data
  });
}

/**
 * 启用/停用设备
 * @param {Object} data - 请求参数
 * @param {number} data.id - 设备ID
 * @param {number} data.status - 状态：0-停用，1-启用
 * @returns {Promise}
 */
export function updateMachineStatus(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/updateStatus',
    method: 'post',
    params: data
  });
}

/**
 * 分页查询设备
 * @param {Object} data - 查询参数
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @returns {Promise}
 */
export function getMachineList(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/page',
    method: 'post',
    data
  });
}

/**
 * 查询所有设备列表
 * @returns {Promise}
 */
export function getAllMachineList() {
  return request({
    baseURL: baseURL,
    url: '/machine/list',
    method: 'get'
  });
}

/**
 * 修改格口数
 * @param {Object} data - 请求参数
 * @param {number} data.machineId - 设备ID
 * @param {number} data.chuteCount - 新格口数量
 * @returns {Promise}
 */
export function updateChuteCount(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/updateChuteCount',
    method: 'post',
    params: data
  });
}

/**
 * 获取格口视图数据
 * @param {Object} params - 查询参数
 * @param {number} params.machineId - 设备ID
 * @returns {Promise}
 */
export function getChuteView(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/chuteView',
    method: 'get',
    params
  });
}

/**
 * 修改格口状态
 * @param {Object} params - 请求参数
 * @param {number} params.chuteId - 格口ID
 * @param {number} params.status - 状态：0-关闭，1-开启，2-满袋
 * @returns {Promise}
 */
export function updateChuteStatus(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/updateChuteStatus',
    method: 'post',
    params
  });
}

/**
 * 清理格口数据
 * @param {Object} params - 请求参数
 * @param {number} params.chuteId - 格口ID
 * @returns {Promise}
 */
export function clearChuteData(params) {
  return request({
    baseURL: baseURL,
    url: `/machine/clearChuteData?chuteId=${params.chuteId}`,
    method: 'post',
    params
  });
}

/**
 * 获取机器关联用户列表
 * @param {Object} params - 查询参数
 * @param {number} params.siteId - 中转仓ID
 * @returns {Promise}
 */
export function getMachineUsers(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/userList?siteId=' + params.siteId,
    method: 'GET'
  });
}

export function exportChuteView(machineId) {
  return request({
    baseURL: baseURL,
    url: `/machine/chuteView/export?machineId=${machineId}`,
    method: 'get'
  });
}

// 清理设备所有数据
export function batchClearAllChuteData(machineId) {
  return request({
    baseURL: baseURL,
    url: `/machine/batchClearAllChuteData?machineId=${machineId}`,
    method: 'post'
  });
}

// 获取所有设备
export function GetMachineList() {
  return request({
    baseURL: baseURL,
    url: '/cargoCount/statistics/machineList',
    method: 'get'
  });
}

// 根据设备id查询配置规则
export function getRuleList(machineId) {
  return request({
    baseURL: baseURL,
    url: `/rule/listByMachineId?machineId=${machineId}`,
    method: 'get'
  });
}

// 格口数据统计
export function cargoCountStatistie(data) {
  return request({
    baseURL: baseURL,
    url: '/cargoCount/statistics/chuteDate',
    method: 'post',
    data
  });
}

// 正常落袋数据统计
export function normalPackage(data) {
  return request({
    baseURL: baseURL,
    url: '/cargoCount/statistics/normalPackage',
    method: 'post',
    data
  });
}

// 异常落袋数据统计
export function abnormalPackage(data) {
  return request({
    baseURL: baseURL,
    url: '/cargoCount/statistics/abnormalPackage',
    method: 'post',
    data
  });
}

// 关闭所有格口
export function closeAllChutes(machineId) {
  return request({
    baseURL: baseURL,
    url: `/machine/closeAllChutes?machineId=${machineId}`,
    method: 'post'
  });
}

// 校验当前设备是否具备规则操作权限
export function checkOperatePermission(params) {
  return request({
    baseURL: baseURL,
    url: '/machine/checkOperatePermission',
    method: 'post',
    params
  });
}

/**
 * 分页查询设备的满袋消息通知
 * @param {Object} data - 请求参数
 * @param {number} data.pageNumber - 页码
 * @param {number} data.pageSize - 每页条数
 * @param {Object} data.params - 查询条件
 * @param {number|string} data.params.machineId - 设备ID
 * @returns {Promise}
 */
export function getChuteNoticePage(data) {
  return request({
    baseURL: baseURL,
    url: '/machine/chuteNotice/page',
    method: 'post',
    data
  });
}
